module.exports = __webpack_public_path__ + "b2a1595f0b4f50731b6eee4f1ba1d43f.mp3";